import { IUserPermissionPresenterSchema } from '../../repositories/monolith-python/entities/presenters/UserPermissionPresenterSchema';
import { IUserPhoneSchema } from '../../repositories/monolith-python/entities/user/UserPhoneSchema';

export interface IUser {
  /** Тип агента **/
  accountType?: string | null;
  /** Тип агента **/
  agentAccountType?: string | null;
  /** Ссылка на аватар пользователя/агента **/
  avatarUrl?: string | null;
  /** Баланс пользователя **/
  balance?: number | null;
  /** Может ли пользователь опубликовывать объявления и вакансии **/
  canPublishOffer?: string | null;
  /** md5 от емайла пользователя, если он фейковый отдаем None **/
  criteoEmail?: string | null;
  /** Имя пользователя/агента **/
  displayName?: string | null;
  /** Емайл пользователя, если он фейковый отдаем None **/
  email?: string | null;
  /** Имя **/
  firstName?: string | null;
  /** Cian ID пользователя **/
  id?: number | null;
  /** Агент ли пользователь **/
  isAgent?: boolean | null;
  /** Авторизован ли пользователь **/
  isAuthenticated?: boolean | null;
  /** Является ли пользователь застройщиком **/
  isBuilder?: boolean | null;
  /** Партнер ЦИАН **/
  isCianPartner?: boolean | null;
  /** Модератор ли пользователь **/
  isModerator?: boolean | null;
  /** Новый ли пользователь **/
  isNew?: boolean | null;
  /** Профи ли пользователь **/
  isProfi?: boolean | null;
  /** Есть ли подписки у пользователя **/
  isSubscriptions?: boolean | null;
  /** Контрольная сумма пользователя для чата webim КпН (Консультантов по Новостройкам) **/
  kpnWebimChecksum?: string | null;
  /** Фамилия **/
  lastName?: string | null;
  permissions: IUserPermissionPresenterSchema;
  /** Телефон **/
  phones?: IUserPhoneSchema[] | null;
  /** Имеет ли пользователь публичный профиль **/
  publicProfile?: string | null;
  /** Пакеты пользователя **/
  tariff?: string[] | null;
  /** Realty ID пользователя **/
  userId?: number | null;
  /** Уровень доверия **/
  userTrustLevel?: EUserTrustLevel | null;
  /** Тип пользователя **/
  userType?: string | null;
}

export enum EUserTrustLevel {
  /** Очень много жалоб **/
  Danger = 'danger',
  /** Исключен из программы **/
  Excluded = 'excluded',
  /** участвует **/
  Involved = 'involved',
  /** Новый пользователь **/
  New = 'new',
  /** не участвует **/
  NotInvolved = 'notInvolved',
}

export interface IUsersResponse {
  statusCode: 200;
  headers: [string, string][];
  response: {
    user: IUser;
  };
}

export interface IUsersResponseError {
  statusCode: 400;
  headers: [string, string][];
  response: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    errors: any[];
    message: string;
  };
}
